import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { COMPANY } from "@/mock";

const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta"
      className="relative overflow-hidden bg-brand-ink"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1635221798248-8a3452ad07cd?q=85&w=2000&auto=format&fit=crop"
          alt="Craftsman at work"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-ink/95 via-brand-ink/70 to-brand-ink/40" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-brand-cta mb-6 flex items-center gap-3">
              <span className="block w-10 h-px bg-brand-cta" />
              Free, no-pressure estimate
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter text-white leading-[0.95] mb-8">
              Tell us about <br />
              <span className="italic font-light">your project.</span>
            </h2>
            <p className="text-base lg:text-lg text-white/70 max-w-xl leading-relaxed">
              We respond to every inquiry within 24 hours and book site visits
              in 3-7 days. No hard sells. No commission contractors. Just an
              honest plan and an honest price.
            </p>
          </div>

          <div className="lg:col-span-5 flex flex-col gap-3">
            <Link
              to="/contact"
              data-testid="finalcta-quote"
              className="group inline-flex items-center justify-between gap-3 px-7 py-6 bg-brand-cta hover:bg-brand-ctaHover text-white text-sm font-bold uppercase tracking-[0.16em] transition-colors"
            >
              Request your estimate
              <ArrowUpRight
                className="w-5 h-5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                strokeWidth={2}
              />
            </Link>
            <a
              href={`tel:${COMPANY.phone.replace(/[^0-9+]/g, "")}`}
              data-testid="finalcta-call"
              className="inline-flex items-center justify-between gap-3 px-7 py-6 border border-white/30 hover:border-white text-white text-sm font-bold uppercase tracking-[0.16em] transition-colors"
            >
              {COMPANY.phone}
              <Phone className="w-5 h-5" strokeWidth={2} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
